import { Modal } from "antd";
import PaymentIcon from "../../../assets/images/vectors/SideBarIcons/PaymentIcon";
import { PurchaseLicenseItemForm } from "./PurchaseLicenseItemForm";
import { PurchaseLicenseItemPicker } from "./PurchaseLicenseItemPicker";

const PurchaseLicenseItemModal = ({
  open,
  setOpen,
  purchaseId,
  deviceNo,
  editingItem,
  setEditingItem,
  existingItems = [],
  showRenewal = false,
  onSaved,
}) => {
  const isEdit = editingItem?.ItemNo != null;

  const handleClose = () => setOpen(false);

  return (
    <Modal
      open={open}
      closable={false}
      onCancel={handleClose}
      // Clearing editingItem mid close-animation would switch to add mode (width/content) while fading out.
      afterClose={() => setEditingItem?.(null)}
      footer={null}
      width={isEdit ? 580 : 1200}
      centered
      destroyOnClose
      title={
        <div className="flex items-center bg-gray-200 p-2 rounded-md">
          <PaymentIcon className="text-[18px] text-black" />
          <span className="text-[14px] font-[Poppins] text-black ml-2">
            {isEdit ? "Edit License item" : "Add License item"}
          </span>
        </div>
      }
    >
      {isEdit ? (
        <PurchaseLicenseItemForm
          purchaseId={purchaseId}
          deviceNo={deviceNo}
          editingItem={editingItem}
          existingItems={existingItems}
          showRenewal={showRenewal}
          onCancel={handleClose}
          onSaved={onSaved}
        />
      ) : (
        <PurchaseLicenseItemPicker
          purchaseId={purchaseId}
          deviceNo={deviceNo}
          existingItems={existingItems}
          showRenewal={showRenewal}
          onCancel={handleClose}
          onSaved={onSaved}
        />
      )}
    </Modal>
  );
};

export default PurchaseLicenseItemModal;
